import React from 'react';
import { Link } from 'react-router-dom';
import './ROHSCertificate.css';

const ROHSCertificate = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">Quality Certification</div>
            <h1 className="page-title">ROHS Certificate</h1>
            <div className="page-text-content">
              <p>
                Hello Valued Visitors,
              </p>
              <p>
                As NQC (Nova Quality Certification Agency), we take pride in being a professional 
                service provider with extensive experience in certification and documentation. We 
                continue our commitment to providing high-quality services, and today we aim to focus 
                on one of the services we offer: the ROHS Certificate.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is ROHS?</h2>
            <div className="page-text-content">
              <p>
                ROHS stands for Restriction of Hazardous Substances, which is an abbreviation for 
                limiting the use of hazardous substances in electronic and electrical equipment, 
                promoting the production of environmentally friendly products. The ROHS Certificate 
                allows businesses to declare compliance with the rules in their products.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Should You Obtain an ROHS Certificate?</h2>
            <div className="reasons-list">
              <div className="reason-item">
                <h3 className="reason-title">1. Environmental Respect and Human Health</h3>
                <p className="reason-description">
                  The ROHS Certificate demonstrates your environmental respect, prioritizes human 
                  health, reduces environmental pollution, and protects human health by restricting 
                  hazardous substances.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">2. Product Safety</h3>
                <p className="reason-description">
                  The ROHS Certificate guarantees that your products are safe and free from hazardous 
                  substances, increasing customer trust and enhancing product safety.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">3. Market Access</h3>
                <p className="reason-description">
                  Many countries and markets prefer ROHS certified products, which can expand your 
                  access to international markets and provide a competitive advantage.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">4. Legal Compliance</h3>
                <p className="reason-description">
                  ROHS Certification has become a legal requirement in many countries. Having this 
                  certificate can help you avoid legal issues and prove the compliance of your 
                  products with regulations.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">How to Obtain an ROHS Certificate?</h2>
            <div className="page-text-content">
              <p>
                To obtain an ROHS Certificate, you need to review your products and limit the use of 
                hazardous substances. NQC (Nova Quality Certification Agency) guides you through this 
                process. Our experienced experts evaluate the compliance of your products with ROHS 
                requirements and assist you in obtaining the necessary certification.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Choose NQC (Nova Quality Certification Agency)?</h2>
            <div className="page-text-content">
              <p>
                At NQC (Nova Quality Certification Agency), we offer various certification services, 
                including the ROHS Certificate, with extensive experience in different fields. We 
                provide customized solutions tailored to your business needs and manage the 
                certification process effectively for you.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Final Words</h2>
            <div className="page-text-content">
              <p>
                The ROHS Certificate is an important certification that demonstrates your business's 
                commitment to environmental responsibility and human health. We are proud to assist 
                your business in obtaining this valuable certificate. We are happy to collaborate with 
                you to promote the production of environmentally friendly products and create a cleaner 
                environment worldwide.
              </p>
              <p>
                If you have any questions or need more information about our certification services, 
                our expert team will be happy to assist you.
              </p>
              <p>
                Best regards!
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ROHSCertificate;

